let password;

function checkPassword(rule, value, callback) {
    if (!value) return callback(new Error('密码不可以为空'));
    password = value;
    console.log(password);
    if (/^(?!\d+$)[A-Za-z0-9]{6,}$/.test(value)) {
        return callback();
    }
    return callback(new Error('要求至少6位，允许字母和数字，不可以纯数字'));
}

function confirmPassword(rule, value, callback) {
    if (!value) return callback(new Error('密码不可以为空'));
    if (value === password) {
        password='';
        return callback();
    }
    return callback(new Error('两次密码不相同'));
}

export default {
    fields: {
        username: {type: 'primary', title: '用户名'},
        nickname: {title: '昵称', width: 150, placeholder: '请输入新昵称'},
        nickname_copy: {title: '当前昵称', width: 150, show_type: 'info'},
        phone: {title: '电话', width: 150},
        phone_verify: {title: '短信验证码', type: 'phone-code', placeholder: '请输入验证码', url: '/bbs/user/pco'},
        coin: {title: '积分', width: 150},
        login_password: {
            title: '密码',
            width: 150,
            type: 'password',
            placeholder: '留空表示不修改，至少6个字符，不可以全数字'
        },
        re_password: {title: '确认密码', width: 150, type: 'password'},
        group_id: {title: '用户组', type: 'checkbox', dict_key: 'bbs_user_group'},
        tip: {title: '备注'},
        create_time: {title: '创建时间', type: 'date', format: 'Y-m-d'},
    },
    rules: {
        username: [
            {required: true, message: '用户名不可以为空', trigger: 'blur'},
        ],
        staff_name: [
            {required: true, message: '员工名不可以为空', trigger: 'blur'},
        ],
        login_password: [
            {required: true, message: '密码不可以为空', trigger: 'blur'},
            {validator: checkPassword, trigger: 'change'}
        ],
        re_password: [
            {required: true, message: '密码不可以为空', trigger: 'blur'},
            {validator: confirmPassword, trigger: 'change'}
        ],
        group_id: [
            {required: true, message: '请指定用户组', trigger: 'change'},
        ],
    },
    group: {
        show: {
            fields: ['username', 'phone', 'nickname', 'group_id', 'tip', 'create_time'],
        },
        search: {
            fields: ['username', 'phone'],
        },
        edit_user: {
            fields: ['username', 'group_id', 'login_password', 'tip'],
            title: '修改用户',
            data: {},
            show: true,
        },
        unbind_wx: {
            fields: ['phone_verify'],
            title: '解绑微信',
            data: {},
            show: true,
        },
        edit_nickname: {
            fields: ['nickname_copy', 'phone_verify', 'nickname'],
            title: '修改昵称',
            data: {},
            show: true,
        },
        edit_password: {
            fields: ['login_password', 're_password', 'phone_verify'],
            title: '修改密码',
            data: {},
            show: true,
        },
        add_user: {
            fields: ['username', 'staff_name', 'group_id', 'password'],
            title: '新增用户',
            data: {},
            show: true,
        },
    }
}
